

import React from 'react'
import { useFocusByProp } from './useFocusByProp'
import TranslationCont from '../../General/TranslationCont'


// ToDO: Als NavButton nutzen
const ButtonFocusAccess = ({
    buttonTransId,
    buttonText,
    hasFocus,
    ...props
}) => {
    const [itemRef] = useFocusByProp(hasFocus)

    //ToDo: Was ist mit label?

    return (
        <button 
            type="button"
            ref={itemRef}
            {...props}
        >
            <span className="access-focus text-medium access-typo">
                {buttonTransId ? (
                    <TranslationCont id={buttonTransId}>{buttonText}</TranslationCont>
                ) : (
                    buttonText
                )}
            </span>
        </button>
    )
}

export default ButtonFocusAccess